module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_stats_tiles-3cfc799db1c0c89d2774c1e286db2a5a.png";